<div class="ra-search-select" [class.ra-search-select--open]="open" [class.ra-search-select--disabled]="disabled">
  <label *ngIf="label" class="ra-search-select__label">
    {{ label }}<span *ngIf="required" class="ra-search-select__required"> *</span>
  </label>

  <div
    #trigger
    class="ra-search-select__trigger"
    [class.ra-search-select__trigger--disabled]="disabled"
    role="button"
    [attr.tabindex]="disabled ? -1 : 0"
    [attr.aria-disabled]="disabled"
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="$event.preventDefault(); toggle()"
  >
    <span class="ra-search-select__value" [class.ra-search-select__value--placeholder]="!value">
      {{ value || placeholder }}
    </span>
    <button
      *ngIf="value && !disabled"
      type="button"
      class="ra-search-select__clear"
      (click)="clear($event)"
      title="Clear"
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
    <span class="ra-search-select__chevron" [class.ra-search-select__chevron--hidden]="value && !disabled">
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  </div>

  <ng-container *ngIf="open">
    <div class="ra-search-select__backdrop" (click)="close()"></div>
    <div class="ra-search-select__panel" [ngStyle]="panelStyle">
      <div class="ra-search-select__search-row">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/>
          <path d="m20 20-3-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <input
          class="ra-search-select__search-input"
          [value]="query"
          (input)="onQueryChange($event.target.value)"
          [placeholder]="searchPlaceholder"
          autofocus
        />
      </div>
      <div class="ra-search-select__options">
        <button
          *ngFor="let option of filtered"
          type="button"
          class="ra-search-select__option"
          [class.ra-search-select__option--selected]="option === value"
          (click)="pick(option)"
        >
          <span class="ra-search-select__option-label">{{ option }}</span>
          <svg *ngIf="option === value" class="ra-search-select__check" width="17" height="17" viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div *ngIf="filtered.length === 0" class="ra-search-select__no-match">
          No matches for "{{ query }}"
        </div>
      </div>
    </div>
  </ng-container>
</div>
